const doc = [({"en":({"pattern1":"Search form, Main image", "pattern2":"Main image, Search form"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;